import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=7765e8b2&scoped=true"
import script from "./Confirm.vue?vue&type=script&lang=ts"
export * from "./Confirm.vue?vue&type=script&lang=ts"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=7765e8b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7765e8b2",
  null
  
)

export default component.exports